<template>
  <div id="app" v-loading.fullscreen.lock="loadings.length > 0" element-loading-background="rgba(255, 255, 255, 0.7)"
    :element-loading-text="loadings.length > 0 && loadings[0].desc">
    <a-locale-provider :locale="zhCN">
      <router-view />
    </a-locale-provider>

  </div>
</template>


<script>
//import _ from 'lodash';
import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
export default {
  data() {
    return {
      zhCN: zhCN,
    }
  },
  computed: {
    loadings() {
      return this.$root.loadingTasks || [];
    },
  },
  methods: {},
  mounted() { },
};
</script>


<style>
/* 全局 */
body {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

#app {
  height: 100vh;
}

.mypopover.el-popover {
  min-width: 120px !important;
}

#__vconsole {
  display: none;
}

/*iphoneX*/
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .van-tabbar--fixed {
    padding-bottom: 10px !important;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}

/*iphoneX Max*/
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .van-tabbar--fixed {
    padding-bottom: 10px !important;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
